import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { BrandService } from "@/src/BrandService";
import Container from "@/src/components/atoms/Container/Container";
import Socials from "./Socials";
import Copy from "./Copy";
import FooterMenu from "./FooterMenu";
import { Button } from "@/src/components/v2/Button/Button";
import { SmartLink } from "@/src/components/v2/SmartLink/SmartLink";
import { SmartImage } from "../../v2/SmartImage/SmartImage";
import { useCartTitle } from "@/src/hooks/useCartTitle";
import { resolveCtaLink } from "@/src/utils/resolveCtaLink";

const BRAND_DATA = BrandService.getCurrentBrandData();
const footerMenus = BrandService.getCurrentBrandContent().menus.siteFooter;

export const SiteFooter = ({ customCtaLink }: { customCtaLink?: string; customCtaText?: string }) => {
    const [isHydrated, setIsHydrated] = useState(false);
    const { name, countryCode, alternateLanguageSites } = BRAND_DATA;
    const altLocale = countryCode === "US" ? "en-CA" : "en-US";
    const altSite = alternateLanguageSites?.filter(site => site.locales.includes(altLocale))[0];
    const altCountry = `${altLocale === "en-US" ? "the " : ""} ${altSite?.country}`;
    const cartTitle = useCartTitle();
    const router = useRouter();
    const ctaLink = resolveCtaLink({ customCtaLink, returnFormId: router.query.returnFormId });
    useEffect(() => {
        setIsHydrated(true);
    }, []);
    return (
        <>
            {isHydrated && (
                <div className="footer-sticky-cta fixed bottom-0 z-[10] w-full md:hidden">
                    <Button title={cartTitle} className="mx-auto block cursor-pointer !rounded-none font-semibold" style="Primary" href={ctaLink} id="cta-quote" addArrow />
                </div>
            )}
            <footer className="mt-6 max-md:pb-12" data-testid="siteFooter">
                <Container>
                    <div className="flex flex-col gap-8 rounded-t-[2rem] bg-background-contrast px-6 py-8 md:gap-10 md:py-10 lg:px-10 xl:gap-20 xl:px-[7.25rem] xl:py-20 2xl:px-[8rem]">
                        {/* Top Row */}
                        <div className="flex flex-col gap-8 md:gap-10 xl:justify-between">
                            {/* Logo,social */}
                            <div className="flex flex-col justify-between gap-6 sm:flex-row">
                                <div className="h-10 w-[89px]">
                                    <SmartLink href="/" aria-label={name}>
                                        <SmartImage image={require("../../../media/logo-white.svg")} alt={name} objectFit="scale-down" />
                                    </SmartLink>
                                </div>
                                <Socials />
                            </div>
                            <div className="flex flex-col gap-4 sm:flex-row md:gap-12 xl:gap-20" data-testid="siteFooterMenus">
                                {footerMenus.map((menu, index) => (
                                    <FooterMenu key={index} title={menu.title} links={menu.links} className={menu.className} />
                                ))}
                            </div>
                        </div>
                        <div className="border-b border-t border-border-light-transparent py-4 text-center text-caption font-normal text-text-contrast">
                            Are you looking for{" "}
                            <a href={altSite?.origin} className="underline">
                                Pet Insurance in {altCountry}
                            </a>
                            ?
                        </div>
                        <Copy />
                    </div>
                </Container>
            </footer>
        </>
    );
};
